import { Component } from 'react'
import PropTypes from 'prop-types'
import JsxParser from 'react-jsx-parser'
import ImageLink from '../ImageLink'
import { H1, H2, H3, H4, H5, H6, Body1, Body2, Subtitle1, Subtitle2, Caption, ButtonText, Overline } from '../../Nodes/Typography'
import Container from '../../Nodes/Container'
import Section from '../../Nodes/Section'
import Icon from '../../Nodes/Icon'
import CDLMap from '../CDLMap'
import Collapse from '../Collapse'
import Share from '../Share'
import Tabs from '../Tabs'
import Tab from '../Tabs/Tab'
import Faq from '../../Features/Faq'
import Contact from '../../Features/Contact'
import { graphqlFetch, replaceAll } from '../../../utilities'
import { logEvent } from '../../../../../utilities'

class RenderedPage extends Component {
    state = { pageId: '' }

    updatePage = () => {
        const { pageId } = this.props 

        if (pageId && pageId !== this.state.pageId) {
            graphqlFetch('wcms3', `
                query {
                    pages (where: { pageId: { eq: "${pageId}" }}) {
                        id
                        page_id: pageId
                        title
                        body
                    }
                }`)
                .then(res => {
                    if (res.data.pages.length > 0) {
                        const page = { 
                            ...res.data.pages[0], 
                            body: this.formatBody(res.data.pages[0].body) 
                        }

                        this.setState({ page, pageId })
                        logEvent({ 'Page_Viewed': page['page_id'] })
                    }
                    else if (window)
                        window.location.href = '/'
                })
        }
    }

    formatBody = str =>
        replaceAll(
            str, 
            { '&gt;': '>', '&lt;': '<', '<p>': '', '</p>': '', '&amp;': '&', '<br /><br />': '', '\n': '', '&nbsp;': ' ' })

    render() {
        const components = {
            H1, H2, H3, H4, H5, H6, Body1, Body2, Subtitle1, Subtitle2, Caption, ButtonText, Overline,
            CDLMap, Contact, Faq,
            Container, Section, ImageLink,
            Icon, Collapse, Share, Tabs, Tab,
            ...this.props.components
        }

        return this.state.page ?
        (
            <div id={this.state.page['page_id']}>
                <JsxParser 
                    components={components}
                    jsx={this.state.page.body} 
                    onError={(e) => console.log({e})}/>
            </div>
        ) : null
    }

    componentDidMount() {
        this.updatePage()
    }

    componentDidUpdate() {
        this.updatePage()
    }
}

RenderedPage.propTypes = { 
    pageId: PropTypes.string.isRequired,
    components: PropTypes.object.isRequired
}

export default RenderedPage